var map = {
	"./Comingsoon.png": 4357,
	"./OOPS.png": 13755,
	"./OOPS_Mobile.png": 75510,
	"./StakingDetails.css": 94861,
	"./USDT-icon.png": 13780,
	"./backbtn.png": 90802,
	"./delete.png": 27381,
	"./instagram.svg": 54406,
	"./m-icon.png": 5632,
	"./malltoken.png": 72701,
	"./marketplace-bg.png": 65781,
	"./metamall-coin.png": 57006,
	"./phantom.png": 72213,
	"./rot.svg": 61604,
	"./solflare.png": 10454,
	"./sollet.png": 68977,
	"./stake-token1.png": 60151,
	"./stake-token2.png": 50584,
	"./staking-pool1.png": 41071,
	"./staking-pool10.png": 35191,
	"./staking-pool2.png": 21360,
	"./staking-pool3.png": 5489,
	"./staking-pool4.png": 27716,
	"./staking-pool5.png": 59268,
	"./staking-pool6.png": 60356,
	"./staking-pool7.png": 65205,
	"./staking-pool8.png": 94706,
	"./staking-pool9.png": 33145,
	"./telegram.svg": 74255,
	"./twitter.svg": 86067,
	"./video.png": 55531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99114;